import { Box, Text, Flex, Button, Image } from '@chakra-ui/react'
import { BottomNav } from '@/components/ui/bottom-nav'
import Link from 'next/link'

export default function RewardsGuestView() {
  return (
    <Box pb={10} px={[4, 4, 4, 4]}>
      <Flex
        height={'70vh'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDir={'column'}
      >
        <Image mb={5} src="/guest/rewards.svg" alt="Rewards" boxSize={100} />
        <Text fontSize={32} fontWeight={600} textAlign={'center'}>
          Don&apos;t miss out on earning!
        </Text>
        <Text
          fontSize={20}
          fontWeight={500}
          color={'#7a7a7a'}
          textAlign={'center'}
        >
          Sign in to start earning rewards
        </Text>

        <Flex gap={5} mt={8}>
          <Button
            width={['auto', 'auto', 200]}
            size={'md'}
            bg={'lyk-red'}
            color={'white'}
            as={Link}
            href={'/auth/login'}
          >
            Sign In
          </Button>
          <Button
            width={['auto', 'auto', 200]}
            size={'md'}
            bg={'lyk-green'}
            color={'white'}
            as={Link}
            href={'/how-earnings-work'}
          >
            How earning works
          </Button>
        </Flex>
      </Flex>

      <BottomNav />
    </Box>
  )
}
